import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app';
import { environment } from './environments/environment';

import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID } from '@angular/core';
import { LocaleUtils } from './localeselect/locale';

if (environment.production) {
  enableProdMode();
}

// Get locale from URL (e.g., /management/ru/#/dashboard -> ru)
const urlLocale = LocaleUtils.getLocaleFromUrl();
// Map to supported locale (e.g., ru -> en_US)
const mappedLocale = LocaleUtils.mapping[urlLocale] || 'en_US';
const translations: string = require('raw-loader!./i18n/messages.' +
  mappedLocale +
  '.xlf');

platformBrowserDynamic().bootstrapModule(AppModule, [
  {
    providers: [
      {
        provide: TRANSLATIONS,
        useValue: translations
      },
      { provide: TRANSLATIONS_FORMAT, useValue: 'xliff' },
      { provide: LOCALE_ID, useValue: urlLocale } // Keep original URL locale for display
    ]
  },
  { preserveWhitespaces: environment.production ? false : true }
]);
